import { render, staticRenderFns } from "./SectionTitle2.vue?vue&type=template&id=5f9d8e7e&scoped=true&"
import script from "./SectionTitle2.vue?vue&type=script&lang=js&"
export * from "./SectionTitle2.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitle2.vue?vue&type=style&index=0&id=5f9d8e7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d8e7e",
  null
  
)

export default component.exports